(function($){
  $(document).ready(function(){

    $('.promo-slider').once('sw-promo-slider').each(function() {
      const m = new PromoSlider($(this));
    });

  });
})(jQuery);

class PromoSlider {

  constructor($w){
    const _this = this;

    this.$w = $w;

    // Main slider
    this.$swiper = this.$w.find('.swiper');
    this.swiper = new Swiper(this.$swiper.get(0), {
      loop: true,
      slidesPerView: 1,
      speed: 500,
      followFinger: true,
      autoplay: {
        delay: 4000,
      },
      pagination: {
        el: this.$w.find('.swiper__pagination').get(0),
        type: 'bullets',
        clickable: true,
      },
    });

    this.$w.data('sw-promo-slider', this);
  }

}
